import { useMemo, useState } from "react";
import { Quote, Star, ChevronDown } from "lucide-react";

const REVIEWS = [
  {
    name: "Ginger W.",
    date: "Mar 2024",
    rating: 5.0,
    service: "Small Exterior Home or Structure Painting or Staining",
    text:
      "JJH Painting gave a free estimate and kept with the price!! The painting process was begun with a full cleaning and preparation, even patching stucco before beginning. He was professional, flexible with changes and ideas and respectful! I will continue to do business with him in the future!!!",
  },
  {
    name: "Clayton D.",
    date: "Mar 2023",
    rating: 5.0,
    service: "3–4 Room Interior Painting or Staining",
    text: "He filled holes in drywall and I cannot detect they were there.",
  },
  {
    name: "Wendi P.",
    date: "Jul 2021",
    rating: 5.0,
    service: "Exterior Home or Structure Paint or Stain",
    text:
      "Humberto is fantastic!! Does a great job, is very prompt and completes the work quickly. He’s our painter from now on!!!",
  },
  {
    name: "Cathy G.",
    date: "Jul 2020",
    rating: 5.0,
    service: "5+ Room Interior Painting or Staining",
    text:
      "They did an outstanding job. They worked very hard. YES, yes, yes, I would recommend them.",
  },
  {
    name: "Geoffrey F.",
    date: "May 2020",
    rating: 5.0,
    service: "3–4 Room Interior Painting or Staining",
    text:
      "Humberto did an amazing job! He quoted us a reasonable offer, and because of a desperate need, even showed up on a Saturday to help us. Generous, humble, honest, professional, and quality work describe him best. Truly, if you need someone to paint, just contact Humberto — we won’t go with anyone else for any painting needs as long as we live here. ¡Gracias por todo!",
  },
  {
    name: "Frank S.",
    date: "Apr 2020",
    rating: 5.0,
    service: "Exterior Home or Structure Paint or Stain",
    text: "It was a pleasure dealing with these professionals!",
  },
  {
    name: "Tim B.",
    date: "Dec 2019",
    rating: 5.0,
    service: "5+ Room Interior Painting or Staining",
    price: "$2,499",
    text:
      "Immediate response to our inquiry. Very professional and friendly. Completed painting the ceilings in the whole house in 2-1/4 days. Great job. I will call them again for any future paint jobs we might have.",
  },
  {
    name: "Dex M.",
    date: "Jun 2019",
    rating: 4.5,
    service: "5+ Room Interior Painting or Staining",
    text: "Great work and priced very well compared to others. I'd hire them again for sure.",
  },
  {
    name: "Scott H.",
    date: "Jun 2019",
    rating: 4.5,
    service: "3–4 Room Interior Painting or Staining",
    price: "$2,000",
    text:
      "Humberto, Santana, and Domingo did a great job painting my interior rooms. I plan to get on Humberto's schedule soon to have more rooms painted. Very professional and fairly priced.",
  },
  {
    name: "Lisa C.",
    date: "Apr 2019",
    rating: 5.0,
    service: "Exterior Home or Structure Paint or Stain",
    text:
      "Humberto and his coworkers did an excellent job on our exterior house painting job. Great attention to detail and very nice work overall!",
  },
  {
    name: "David G.",
    date: "Mar 2019",
    rating: 5.0,
    service: "5+ Room Interior Painting or Staining",
    text: "Started on time and finished ahead of schedule. High quality work for a fair price.",
  },
  {
    name: "John D.",
    date: "Jan 2019",
    rating: 5.0,
    service: "Exterior Home or Structure Paint or Stain",
    text:
      "Great communications and started/finished the job quickly. I highly recommend this company.",
  },
  {
    name: "Scott B.",
    date: "Dec 2018",
    rating: 5.0,
    service: "Exterior Home or Structure Paint or Stain",
    text: "Very nice people to work with.",
  },
  {
    name: "Charles B.",
    date: "Jul 2018",
    rating: 5.0,
    service: "Exterior Home or Structure Paint or Stain",
    price: "$5,000",
    text:
      "Humberto and his team were courteous, showed up on time and worked to complete the project quickly. Quality of the work is excellent.",
  },
  {
    name: "Raye A.",
    date: "Mar 2018",
    rating: 5.0,
    service: "Exterior Home or Structure Paint or Stain",
    text:
      "On time, very professional! Attended to detail. The deck was restored to its original appearance. Humberto was outstanding and I have already recommended him to a neighbor. Highly recommend this company!",
  },
  {
    name: "Dan H.",
    date: "Feb 2018",
    rating: 5.0,
    service: "Interior Painting or Staining",
    text:
      "I hired Humberto to work on an interior paint project that included high walls. We had a short timeframe. He responded quickly to our call, came in at a fair price and completed the project to our satisfaction. He has excellent work ethics — arrived promptly, reliable, courteous, worked long and hard and cleaned up after his work each day. I highly recommend Humberto for interior paint jobs.",
  },
  {
    name: "Barbara E.",
    date: "Dec 2017",
    rating: 5.0,
    service: "Exterior Home or Structure Paint or Stain",
    price: "$1,600",
    text:
      "Humberto is the fella who worked on this project and he was great. He showed up when he said he would, he worked long and hard to get the job completed and it looks very nice. I asked him to use a product that has great success in this area and he picked it up and bid the job using the product I requested. I had a time frame and the job was completed in great time. I will hire Humberto again. Very nice man and reliable. Nice job. Clean job site too.",
  },
];

const INITIAL_COUNT = 6;
const CLAMP_CHARS = 220;

export default function Testimonials() {
  const [showAll, setShowAll] = useState(false);
  const [expanded, setExpanded] = useState({});

  const stats = useMemo(() => {
    const total = REVIEWS.length;
    const avg = REVIEWS.reduce((s, r) => s + r.rating, 0) / total;
    return { total, avg };
  }, []);

  const visible = showAll ? REVIEWS : REVIEWS.slice(0, INITIAL_COUNT);

  return (
    <section className="bg-[#FAFAFA] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#0EA5E9]">
              From Our Neighbors
            </div>
            <h2 className="mt-3 font-heading font-black uppercase tracking-tight text-[#334155] text-4xl sm:text-5xl leading-[0.95]">
              What Bay County<br />Is Saying.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <div className="bg-[#334155] text-white p-6 sm:p-8 flex items-center gap-6">
              <div className="flex flex-col items-center">
                <div className="font-heading font-black text-5xl leading-none text-[#0EA5E9]">
                  {stats.avg.toFixed(1)}
                </div>
                <div className="flex mt-2">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={14} className="fill-[#0EA5E9] text-[#0EA5E9]" />
                  ))}
                </div>
              </div>
              <div className="border-l-2 border-white/20 pl-6">
                <div className="font-heading font-bold uppercase tracking-tight text-xl leading-tight">
                  {stats.total} Verified
                  <br />Customer Reviews
                </div>
                <div className="mt-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#94A3B8]">
                  Bay County, FL · 2017 – 2024
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {visible.map((r, i) => {
            const isLong = r.text.length > CLAMP_CHARS;
            const open = expanded[i];
            const text = isLong && !open ? r.text.slice(0, CLAMP_CHARS).trimEnd() + "…" : r.text;
            return (
              <article
                key={`${r.name}-${r.date}`}
                data-testid={`review-card-${i}`}
                className="bg-white border-2 border-[#334155] p-6 sm:p-7 flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <Quote size={26} className="text-[#0EA5E9]" />
                  <div className="flex items-center gap-1.5">
                    <span className="font-heading font-bold text-[#334155]">{r.rating.toFixed(1)}</span>
                    <Star size={14} className="fill-[#0EA5E9] text-[#0EA5E9]" />
                  </div>
                </div>

                <div className="mt-4 text-[11px] font-bold uppercase tracking-[0.18em] text-[#0EA5E9]">
                  {r.service}
                  {r.price && (
                    <span className="ml-2 text-[#4B5563]">· {r.price}</span>
                  )}
                </div>

                <p className="mt-3 text-[15px] leading-relaxed text-[#111827] flex-1">
                  “{text}”
                </p>

                {isLong && (
                  <button
                    onClick={() => setExpanded((e) => ({ ...e, [i]: !e[i] }))}
                    data-testid={`review-toggle-${i}`}
                    className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-[#334155] hover:text-[#0EA5E9] self-start"
                  >
                    {open ? "Show less" : "Read more"}
                  </button>
                )}

                <div className="mt-5 pt-4 border-t border-[#E5E7EB] flex items-center justify-between">
                  <div className="font-heading font-bold uppercase tracking-tight text-[#334155]">
                    {r.name}
                  </div>
                  <div className="text-xs font-semibold uppercase tracking-wider text-[#4B5563]">
                    {r.date}
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {REVIEWS.length > INITIAL_COUNT && (
          <div className="mt-12 flex justify-center">
            <button
              onClick={() => setShowAll((s) => !s)}
              data-testid="reviews-toggle-all"
              className="group inline-flex items-center gap-3 border-2 border-[#334155] bg-white hover:bg-[#334155] hover:text-white transition-colors text-[#334155] px-7 py-4 font-heading font-bold uppercase tracking-wider"
            >
              {showAll ? "Show fewer reviews" : `Read all ${REVIEWS.length} reviews`}
              <ChevronDown
                size={18}
                className={`transition-transform ${showAll ? "rotate-180" : ""}`}
              />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
